module.exports = __webpack_public_path__ + "img/img-02.46c0bed0.png";